// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import ToastedNotes from 'components/ToastedNotes';

const getPortalElement = () => {
  const PORTAL_ID = 'toaster';
  const existingElement = document.getElementById(PORTAL_ID);

  if (existingElement) return existingElement;

  const portalElement = document.createElement('div');
  portalElement.id = PORTAL_ID;

  if (document.body != null) document.body.appendChild(portalElement);

  return portalElement;
};

type NotifyOptionsType = {
  error?: boolean,
  timeout?: number,
  config?: {|
    tension?: number,
    friction?: number,
    precision?: number
  |}
}

class Toaster {
  createNotification: Function;

  constructor() {
    const portalElement = getPortalElement();
    ReactDOM.render(<ToastedNotes notify={this.bindNotify} />, portalElement);
  }

  bindNotify = (fn: Function) => {
    this.createNotification = fn;
  };

  notify = (message: string, options: NotifyOptionsType = {}) => {
    if (this.createNotification) {
      this.createNotification(message, options);
    }
  };
}

export default new Toaster;
